import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Hidden from '@material-ui/core/Hidden';
import styles from './slider-jss';
import EventCard from '../CardPaper/EventCard';
import { fetchCall } from '../../service/service_base';
import GenericCarousel from './GenericCarousel';

class SliderEvent extends React.Component {
  state = {
    eventos: []
  }

  componentDidMount() {
    if (!this.props.isSearching) {
      this._load();
    } else {
      if (this.props.section) {
        this.setState(
          {
            eventos: []
          }, () => {
            this.setState(
              {
                eventos: this.props.section.content
              }
            )
          }
        )
      }
    }
  }

  _load = () => {
    fetchCall("POST", "/synthesis/getcontentpublish", {
      sectionId: this.props.section.sec_id,
      menuId: this.props.idMenuSelected
    }).then(response => {
      this.setState({ eventos: response.data });
    }).catch(err => console.log(err));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isSearching && nextProps.section) {
      this.setState({
        eventos: nextProps.section.content
      });
    }
  }

  getMonthName = (monthNumber) => {
    const months = {
      "01": "Ene", "02": "Feb", "03": "Mar", "04": "Abr",
      "05": "May", "06": "Jun", "07": "Jul", "08": "Ago",
      "09": "Sep", "10": "Oct", "11": "Nov", "12": "Dic"
    };
    return months[monthNumber] || '';
  }

  renderEventCard = (item, index) => {
    const { isSearching } = this.props;
    
    if (item.cont_key) {
      item.cont_imagePath = item.cont_key;
    }
    
    let fecha = isSearching 
      ? (item.cont_imagePath ? item.cont_imagePath.toString() : null) 
      : item.cont_key.toString();
    
    let mes = "", dia = "";
    if (fecha) {
      mes = this.getMonthName(fecha.split("-")[1]);
      dia = fecha.split("-")[2];
    }
    
    const lastItem = index === this.state.eventos.length - 1;
    
    return (
      <EventCard
        title={item.cont_name}
        description={item.cont_description}
        day={dia}
        month={mes}
        publish_date={item.publish_date}
        noDivider={false}
        inCarousel={true}
      />
    );
  }

  render() {
    const { isSearching, section } = this.props;
    const isWhiteBackground = section.sec_color === '' || section.sec_color === '#FFFFFF'; 

    return (
      <>
        <Hidden smDown>
          <Grid container spacing={24}>
            {this.state.eventos.map((item, key) => {
              if (item.cont_key) {
                item.cont_imagePath = item.cont_key;
              }
              
              let fecha = isSearching 
                ? (item.cont_imagePath ? item.cont_imagePath.toString() : null) 
                : item.cont_key.toString();
              
              let mes = "", dia = "";
              if (fecha) {
                mes = this.getMonthName(fecha.split("-")[1]);
                dia = fecha.split("-")[2];
              }
              
              const lastItem = key === this.state.eventos.length - 1;
              
              return (
                <Grid item xs={12} md={6} lg={4} key={key}>
                  <EventCard
                    title={item.cont_name}
                    description={item.cont_description}
                    day={dia}
                    month={mes}
                    publish_date={item.publish_date}
                    noDivider={false}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Hidden>

        <Hidden mdUp>
          <GenericCarousel
            items={this.state.eventos}
            renderItem={this.renderEventCard}
            isWhiteBackground={isWhiteBackground}
          />
        </Hidden>
      </>
    );
  }
}

SliderEvent.propTypes = {
  classes: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
  idMenuSelected: PropTypes.any,
  isSearching: PropTypes.bool,
};

export default withStyles(styles)(SliderEvent);
